// @flow

import React, { Component } from "react";
import { NavHashLink as NavLink } from "react-router-hash-link";

import "./Baner.scss";

export default class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menu: false,
    };
  }

  toggleMenu() {
    this.setState({
      menu: !this.state.menu,
    });
  }

  closeMenu() {
    this.setState({
      menu: false,
    });
  }

  render() {
    return (
      <React.Fragment>
        <section className="evomer-description big-padding">
          <div className="evomer-description_container container row baner-cotainer">
            <div className="col-12 found-banner__col">
              <img
                src="/img/evomer-logo-white.png"
                className="logo-white"
              ></img>
              <p className="h3-red bold-header found-bold__header">
                Masy polimerowo-bitumiczne
              </p>
              <div className="col-12 evomer-desc__row">
                <div className="found-banner-img__conatiner">
                  <img src="/img/foundation-banner.png" ></img>
                </div>
                <div className="found-banner-text__container">
                  <p className="text-basic found-banner__text">
                    Przedstawiamy wyjątkowo szybkie i skuteczne rozwiązania
                    hydroizolacji fundamentów przy pomocy mas polimerowo –
                    bitumicznych EVOMER.
                  </p>
                  <p className="text-basic found-banner__text">
                    Woda jest jednym z większych zagrożeń dla budowli. Dlatego
                    zabezpieczenie przed jej wpływem jest niezwykle istotne dla
                    trwałości konstrukcji i jej bezpiecznego użytkowania.
                    Skuteczne zabezpieczenie fundamentów chroni przed wilgocią i
                    wodą gruntową wnikającą do ścian, a w konsekwencji
                    pojawieniem się wilgoci wewnątrz budynku co może doprowadzić
                    do rozwoju grzybów i pleśni.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Baner/Baner.js